import { BrandMark } from "./BrandMark";
import { EURO_BRANDS } from "@/lib/data";

export const BrandMarquee = () => {
  const row = [...EURO_BRANDS, ...EURO_BRANDS];
  return (
    <section data-testid="brand-marquee" aria-label="European car brands we service" className="marquee-pause relative overflow-hidden bg-brand py-10">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-brand to-transparent md:w-40" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-brand to-transparent md:w-40" />
      <div className="animate-marquee flex w-max items-center">
        {row.map((b, i) => (
          <div key={i} className="group flex items-center gap-5 px-8 text-ink transition-colors duration-500 md:px-12">
            <span className="grid h-14 w-20 place-items-center bg-white p-2 md:h-16 md:w-24" style={{ backgroundColor: "#FFFFFF" }}><BrandMark brand={b} className="h-full w-full" /></span>
            <span className="font-serif-i whitespace-nowrap text-3xl text-ink transition-colors duration-500 group-hover:text-bone md:text-5xl">{b.name}</span>
            <span className="ml-8 h-2 w-2 rotate-45 bg-brand2 md:ml-12" />
          </div>
        ))}
      </div>
    </section>
  );
};
